import React, { useEffect, useRef, useState } from "react";
import { IconButton, Box } from "@mui/material";

const PreviewVideo = ({ file }) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const [progress, setProgress] = useState(0);
  const [videoUrl, setVideoUrl] = useState("");

  // useEffect(() => {
  //   const url = URL.createObjectURL(file);
  //   setVideoUrl(url);
  //   return () => {
  //     URL.revokeObjectURL(url);
  //   };
  // }, [file]);

  useEffect(() => {
    if (!(file instanceof File)) {
      setVideoUrl(file);
      return;
    }

    const url = URL.createObjectURL(file);
    setVideoUrl(url);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [file]);

  const handlePlayPause = (e) => {
    e.stopPropagation();
    if (!videoRef.current) return;
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  const handleMuteUnmute = (e) => {
    e.stopPropagation();
    if (!videoRef.current) return;
    videoRef.current.muted = !isMuted;
    setIsMuted(!isMuted);
  };

  const handleTimeUpdate = () => {
    if (!videoRef.current) return;
    const percent = (videoRef.current.currentTime / videoRef.current.duration) * 100;
    setProgress(percent || 0);
  };

  // Keep isPlaying state in sync with video events
  const handlePlay = () => setIsPlaying(true);
  const handlePause = () => setIsPlaying(false);

  return (
    <Box sx={{ position: "relative", width: "27.396vw", height: "35.42vw", mb: "0.833vw" }}>
      <video
        ref={videoRef}
        src={videoUrl}
        muted={isMuted}
        onClick={handlePlayPause}
        onTimeUpdate={handleTimeUpdate}
        onPlay={handlePlay}
        onPause={handlePause}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "0vw", // 12px → vw
          background: "#000",
          display: "block",
          cursor: "pointer",
        }}
      />
      {/* Play/Pause Button at center */}
      <IconButton
        onClick={handlePlayPause}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "rgba(0,0,0,0.5)",
          color: "#fff",
          zIndex: 2,
          "&:hover": { background: "rgba(0,0,0,0.7)" },
        }}
        size="large"
      >
        {isPlaying ? (
          <svg width="40" height="40" viewBox="0 0 32 32" fill="#fff">
            <rect x="7" y="7" width="6" height="18" rx="2" />
            <rect x="19" y="7" width="6" height="18" rx="2" />
          </svg>
        ) : (
          <svg width="40" height="40" viewBox="0 0 32 32" fill="#fff">
            <polygon points="8,6 26,16 8,26" />
          </svg>
        )}
      </IconButton>
      {/* Mute/Unmute Button */}
      <IconButton
        onClick={handleMuteUnmute}
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          background: "rgba(0,0,0,0.5)",
          color: "#fff",
          zIndex: 2,
          "&:hover": { background: "rgba(0,0,0,0.7)" },
        }}
        size="small"
      >
        {isMuted ? (
          <svg width="20" height="20" fill="#fff" viewBox="0 0 24 24">
            <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63m2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71M4.27 3 3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9zM12 4 9.91 6.09 12 8.18z"></path>
          </svg>
        ) : (
          <svg width="20" height="20" fill="#fff" viewBox="0 0 24 24">
            <path d="M16.5 12c0-1.77-.77-3.29-2-4.29v8.58c1.23-1 2-2.52 2-4.29zm3.5 0c0 2.53-1.17 4.77-3 6.18v-2.06c1.16-.84 2-2.18 2-3.74s-.84-2.9-2-3.74V5.82c1.83 1.41 3 3.65 3 6.18zM4 9v6h4l5 5V4L8 9H4z" />
          </svg>
        )}
      </IconButton>
      {/* Progress Bar */}
      <div
        onClick={(e) => {
          const rect = e.currentTarget.getBoundingClientRect();
          const clickX = e.clientX - rect.left;
          const clickPercentage = clickX / rect.width;

          const video = videoRef.current;
          if (video && video.duration) {
            video.currentTime = clickPercentage * video.duration;
          }
        }}
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          height: 4,
          width: "100%",
          background: "rgba(255,255,255,0.2)",
          borderRadius: "0 0 12px 12px",
          overflow: "hidden",
          cursor: "pointer",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${progress}%`,
            background: "#fff",
            transition: "width 0.2s linear",
          }}
        />
      </div>
    </Box>
  );
};

export default PreviewVideo;
